import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { LOGOS, ICONS } from "./../utils/assets";
import { useGlobalStore } from "../stores/global-store";

const sideBarOptions = [
  {
    name: "Dashboard",
    icon: ICONS.HOME_ICON,
    path: "/dashboard-return",
  },
  {
    name: "Orders",
    icon: ICONS.ORDER_ICON,
    path: "/dashboard-orders",
  },
  {
    name: "Profile",
    icon: ICONS.PROFILE_ICON_PURPLE,
    path: "/dashboard-profile",
  },
];

export const SideBar = () => {
  const { sidebar, closeSidebar } = useGlobalStore();
  const { instance } = useMsal();
  const location = useLocation();
  const [displayCustomerInfo, setDisplayCustomerInfo] = useState([]);

  let activeAccount;
  if (instance) {
    activeAccount = instance.getActiveAccount();
  }

  const handleLogoutRedirect = () => {
    localStorage.clear();
    instance.logoutRedirect({
      account: activeAccount,
      postLogoutRedirectUri: "http://www.quickmove.co.nz",
    });
  };

  useEffect(() => {
    const userInfo = sessionStorage.getItem("LS_CUSTOMER_INFO");

    if (userInfo) {
      setDisplayCustomerInfo(JSON.parse(userInfo));
    }
  }, []);

  return (
    <div className={`sidebar ${sidebar ? "active" : ""}`}>
      <div className="sidebar__logo">
        <img
          className="w-100"
          src={LOGOS.QUICKMOVE_DASH}
          alt="Quickmove logo"
        />
      </div>

      <div className="sidebar__content">
        <nav className="sidebar__nav">
          <p className="paragraph-md text-neutral-950">Main Menu</p>

          <ul className="sidebar__list">
            {sideBarOptions.map((option, index) => (
              <li
                className={`sidebar__item ${
                  location.pathname === option.path
                    ? "sidebar__item--active"
                    : ""
                }`}
                key={index}
              >
                <Link
                  className={`sidebar__link paragraph-md  ${
                    location.pathname === option.path
                      ? "text-primary-500"
                      : "text-neutral-950"
                  }`}
                  to={option.path}
                  onClick={closeSidebar}
                >
                  <img
                    src={option.icon}
                    alt={option.name + " icon"}
                    className="sidebar__icon"
                  />
                  {option.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="logout">
          <button
            className="button button--icon"
            onClick={handleLogoutRedirect}
          >
            <img src={ICONS.LOG_OUT_ICON} alt="Logout" />
          </button>
          <div className="logout__info">
            <div className="paragraph-md semibold text-primary-950">
              {displayCustomerInfo?.displayName}
            </div>
            <div className="paragraph-md text-ellipsis">
              {displayCustomerInfo?.email}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
